import { useState } from "react";
import { components } from "react-select";

export const NoOptionsMessage = (props) => {
	return (
		<components.NoOptionsMessage {...props}>
			<span className="custom-css-class">Sin opciones</span>
		</components.NoOptionsMessage>
	);
};

export const SingleValue = (props) => {
	const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });

	const showTooltip = (event) => {
		const rect = event.target.getBoundingClientRect();
		setTooltipStyle({
			display: "block",
			position: "fixed",
			top: rect.top - 30,
			left: rect.left + rect.width / 2,
			transform: "translateX(-50%)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
			color: "#fff",
			padding: "5px 10px",
			borderRadius: "5px",
			whiteSpace: "nowrap",
			zIndex: 9999,
		});
	};

	const hideTooltip = () => {
		setTooltipStyle({ display: "none" });
	};

	return (
		<components.SingleValue {...props}>
			<div
				style={{
					position: "relative",
				}}
				onMouseEnter={showTooltip}
				onMouseLeave={hideTooltip}
			>
				<span
					style={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
				>
					{props.data.label}
				</span>
				<div style={tooltipStyle}>{props.data.label}</div>
			</div>
		</components.SingleValue>
	);
};
